import {Stack} from '@mantine/core';
import {Application} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";


// FNP-79: Profile renders the legacy admin-create fields plus the FNP-76
// programmatic-provisioning fields when populated. Each section is gated
// on the presence of at least one field so legacy records render the same
// compact profile they always have.
export const Profile = ({record}: { record: Application }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Display Name',
            value: record.displayName as string,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'URL',
            value: record.url as string,
            span: 12,
        }, {
            label: 'Logo URL',
            value: record.logoUrl as string,
            span: 12,
        }];


    const hasProgrammaticFields = !!(
        record.parentDomainName ||
        record.deploymentAccountGroupId ||
        record.sourceRepositoryName ||
        record.infraRepositoryName ||
        record.sourcePipelineId ||
        record.infraPipelineId
    );

    const provisioningProperties = hasProgrammaticFields ? [
        {
            label: 'Parent Domain',
            value: record.parentDomainName as string,
            span: 12,
        },
        {
            label: 'Deployment Account Group',
            value: record.deploymentAccountGroupId as string,
            span: 12,
        },
        {
            label: 'Source Repository',
            value: record.sourceRepositoryName as string,
            span: 12,
        },
        {
            label: 'Infrastructure Repository',
            value: record.infraRepositoryName as string,
            span: 12,
        },
        {
            label: 'Source Pipeline',
            value: record.sourcePipelineId as string,
            span: 12,
        },
        {
            label: 'Infrastructure Pipeline',
            value: record.infraPipelineId as string,
            span: 12,
        },
    ] : null;


    const hasStageDomains = !!(record.stageDomains?.dev || record.stageDomains?.test || record.stageDomains?.prod);

    const stageDomainProperties = hasStageDomains ? [
        {
            label: 'Dev',
            value: record.stageDomains?.dev as string,
            span: 12,
        },
        {
            label: 'Test',
            value: record.stageDomains?.test as string,
            span: 12,
        },
        {
            label: 'Prod',
            value: record.stageDomains?.prod as string,
            span: 12,
        },
    ] : null;


    const properties2 = [
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? [record.createdBy.givenName, record.createdBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateApplication',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }, {
            label: 'Updated By',
            value: typeof record.updatedBy !== 'undefined' && record.updatedBy !== null ? [record.updatedBy.givenName, record.updatedBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateApplication',
            span: 12,
        }];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            {provisioningProperties ? <PlatformPropertyCard properties={provisioningProperties}/> : null}
            {stageDomainProperties ? <PlatformPropertyCard properties={stageDomainProperties}/> : null}
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
